import StepsModal, { type ModalStep } from '@/components/Shared/StepsModal'

const STEPS: ModalStep[] = [
  {
    number: '01',
    title: 'Build your profile from your AI usage',
    description:
      'Connect GitHub, Hugging Face, arXiv, Kaggle — or import your résumé. Build your AI profile and get a public link to share.',
  },
  {
    number: '02',
    title: 'Take an optional AI assessment at your own time',
    description:
      'Solve a real problem with an LLM of your choice. Not a puzzle or imaginary design discussion — a task that shows how you think and build with AI.',
  },
  {
    number: '03',
    title: 'Get hired for what you can do',
    description:
      'Organizations search verified skills, not résumé keywords. Get matched to get hired - not for more tech rounds.',
  },
  {
    number: '04',
    title: 'Browse or be found',
    description:
      'Explore companies hiring AI individuals — or set your availability and let the right organizations come to you.',
  },
]

interface CandidateHowItWorksProps {
  isOpen: boolean
  onClose: () => void
}

export default function CandidateHowItWorks({ isOpen, onClose }: CandidateHowItWorksProps) {
  return (
    <StepsModal
      isOpen={isOpen}
      onClose={onClose}
      label="For candidates"
      title="How it works."
      steps={STEPS}
      footerText="Free for individuals — always."
      footerCta="Ready? Sign in →"
    />
  )
}
